import {
    Component,
    effect,
    inject,
    input,
    InputSignal,
    signal,
    ViewEncapsulation
} from '@angular/core';
import {TOOLTIP_SHOW_DELAY} from "../../shared/globals";
import {ModelID} from "../../_typing/generic-types";
import {AppScope} from "../../services/app_scope.service";
import {DownloadService} from "../../services/csv-download.service";
import {PrintoutFormat} from "../../_typing/printout-formats";
import {ComponentPrintoutService} from "../../services/component-printout.service";
import {OptionListSearchComponent} from "../option-list-search/option-list-search.component";
import {COMMON_FORM_IMPORTS} from "../../shared/import-groups/Common";
import {FilterByValuePipe} from "../../shared/pipes";
import {MatMenuItem} from "@angular/material/menu";


@Component({
    selector: 'component-printout-menu',
    templateUrl: './component-printout-menu.component.html',
    styleUrl: './component-printout-menu.component.scss',
    imports: [
    OptionListSearchComponent,
    FilterByValuePipe,
    MatMenuItem,
    COMMON_FORM_IMPORTS
],
    encapsulation: ViewEncapsulation.None
})
export class ComponentPrintoutMenuComponent {

    downloadService: DownloadService = inject(DownloadService)
    printoutService: ComponentPrintoutService = inject(ComponentPrintoutService)
    printoutFilter: string = '';
    _allowOtherFormats = signal(false);
    public PrintoutFormat: typeof PrintoutFormat = PrintoutFormat;

    inputComponentId: InputSignal<ModelID> =  input.required<ModelID>();
    readonly printoutItems = signal<any[]>([]); // initial signal

    readonly inputPrintoutsAllowed: InputSignal<ModelID[]> =  input();
    protected readonly TOOLTIP_SHOW_DELAY = TOOLTIP_SHOW_DELAY;
    constructor(appScope: AppScope) {
        this.allowOtherFormats = Boolean(appScope.config_name_map.support_other_formats?.value);
      effect(() => {
        const id = this.inputComponentId();
        const allowed = this.inputPrintoutsAllowed();
        this.printoutService.getPrintouts(id, allowed)
          .subscribe((items: any[]) => this.printoutItems.set(items));
      });
    }

    get allowOtherFormats(): boolean {
        return this._allowOtherFormats()
    }

    set allowOtherFormats(value: boolean) {
        this._allowOtherFormats.set(value)
    }

    filterPrintouts = (item, filter) => {
        if (!filter) {
            return true;
        }
        return item?.name?.toLowerCase().includes(filter.toLowerCase());
    }

    trackByPrintout(index, printout) {
        return printout.name;
    }

    downloadPrintout(url: string, format: PrintoutFormat): void {
        this.downloadService.downloadPrintout(url, format)
    }
}
